let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kWUqT")).then(() => parcelRequire('cU5Kj'));